<template>
  <div id="app">
    <Nav/>
    <main>
      <transition name="slide-fade">
        <router-view :key="$route.fullPath"/>
      </transition>
    </main>
    <vue-progress-bar/>
  </div>
</template>

<script>
import Nav from './components/Nav.vue';

export default {
  name: 'App',
  mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish();
  },
  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
      //  finish the progress bar
      this.$Progress.finish();
    });
  },
  components: {
    Nav,
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Jomolhari');
body {
  background-color: color(dark-gray);
}
#app {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  font-family: 'Jomolhari', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: color(white);
  background: url('./assets/bg.png');
  position: relative;
  min-height: 100vh;
  @include respond-to(medium) {
    flex-wrap: nowrap;
  }
}

main {
  margin-top: spacing(double);
  width: 100%;
  margin: 0;
  overflow-x: hidden;
  @include respond-to(medium) {
    margin-top: 0;
    border-left: 1px solid color(light-gray);
  }
}
</style>
